import Renderer from "../renderers/renderer"

export default class EndRenderer extends Renderer {
  get buttons() {
    return []
  }

  get text() {
    return this.node.dataset.name
  }
}
